import React from "react";

import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./ButtonGroupIcon.module.scss";

interface Props extends FontAwesomeIconProps {}

const ButtonGroupIcon: React.FC<Props> = ({ className, ...props }) => {
  return <FontAwesomeIcon className={cn(styles.icon, className)} size="3x" {...props} />;
};

export default ButtonGroupIcon;
